import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { trackEvent } from 'dibs-tracking';

import { SOURCING_PROMPT_MODAL_ORIGIN_PROJECT } from 'dibs-trade-sourcing/exports/constants';

const ProjectTagTradeSourcingPromptModalLazy = React.lazy(() =>
    import(/* webpackChunkName: "TradeSourcingPromptModal" */ './TradeSourcingPromptModal')
);

const trackSourcingEvent = label => {
    trackEvent({
        category: 'trade features',
        action: 'trade sourcing',
        label,
    });
};

export function ProjectTagTradeSourcingPromptModal({ itemId, environment, onClose, onOpen }) {
    const [isOpen, setIsOpen] = useState(true);
    useEffect(() => {
        if (isOpen) {
            onOpen();
            trackSourcingEvent('item added to project - modal displayed');
        }
    }, [isOpen, onOpen]);
    return (
        <React.Suspense fallback={null}>
            <ProjectTagTradeSourcingPromptModalLazy
                isOpen={isOpen}
                itemId={itemId}
                environment={environment}
                modalOrigin={SOURCING_PROMPT_MODAL_ORIGIN_PROJECT}
                onClose={() => {
                    setIsOpen(false);
                    onClose();
                }}
                onSourcingClick={() => trackSourcingEvent('item added to project - cta clicked')}
            />
        </React.Suspense>
    );
}

ProjectTagTradeSourcingPromptModal.propTypes = {
    itemId: PropTypes.string.isRequired,
    environment: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    onOpen: PropTypes.func.isRequired,
};
